var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOwnRentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.16 8.0402L15.16 4.4702C13.36 2.8602 10.64 2.8602 8.84 4.4702L4.84 8.0402C3.83 8.9402 3.25 10.2302 3.25 11.5902V17.9502C3.25 20.0502 4.93 21.7602 7 21.7602H17C19.07 21.7602 20.75 20.0502 20.75 17.9502V11.5902C20.75 10.2402 20.17 8.9402 19.16 8.0402ZM14.25 20.2502H9.75V17.0002C9.75 15.7602 10.76 14.7502 12 14.7502C13.24 14.7502 14.25 15.7602 14.25 17.0002V20.2502ZM19.25 17.9402C19.25 19.2102 18.24 20.2502 17 20.2502H15.75V17.0002C15.75 14.9302 14.07 13.2502 12 13.2502C9.93 13.2502 8.25 14.9302 8.25 17.0002V20.2502H7C5.76 20.2502 4.75 19.2202 4.75 17.9402V11.5802C4.75 10.6502 5.15 9.7702 5.84 9.1502L9.84 5.5802C11.07 4.4802 12.93 4.4802 14.16 5.5802L18.16 9.1502C18.85 9.7702 19.25 10.6502 19.25 11.5802V17.9402Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOwnRentIcon);
export default __webpack_public_path__ + "static/media/own_rent_icon.84704959e92a2352b3a6f0a647919487.svg";
export { ForwardRef as ReactComponent };